import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { beginXSignIn, friendlyApiError } from "@/lib/api";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

function XIcon({ className }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  );
}

export default function AuthModal({ open, onClose, initialRef }) {
  const [xLoading, setXLoading] = useState(false);

  const continueWithX = async () => {
    setXLoading(true);
    try {
      await beginXSignIn("login", initialRef || null);
    } catch (err) {
      if (err.response?.status === 503) {
        toast.error("Sign in with X is not available yet. Please try again later.");
      } else {
        toast.error(friendlyApiError(err, "Unable to reach X. Please try again."));
      }
      setXLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent
        data-testid="auth-modal"
        className="bg-[#0d1017] border border-[#1b2234] text-slate-100 sm:max-w-md p-0 clip-terminal overflow-hidden"
      >
        <div className="relative overflow-hidden">
          <div className="p-8 pt-10">
            <DialogHeader>
              <div className="font-mono-cyber text-[10px] uppercase tracking-[0.35em] text-[#00f0ff] mb-2">
                // Access Osteon
              </div>
              <DialogTitle className="font-editorial text-3xl font-normal text-white">
                Enter the <span className="italic text-[#00f0ff]">archive</span>.
              </DialogTitle>
              <p className="text-sm text-slate-400 mt-3 font-editorial italic leading-relaxed">
                Sign in with X to enter. You can add your wallet address afterwards.
              </p>
            </DialogHeader>

            <div className="mt-8">
              <Button
                type="button"
                onClick={continueWithX}
                disabled={xLoading}
                data-testid="auth-x-btn"
                className="w-full rounded-none clip-notch h-12 bg-white hover:bg-white/90 text-black font-mono-cyber uppercase tracking-widest text-xs"
              >
                {xLoading ? (
                  <Loader2 className="w-4 h-4 animate-spin" />
                ) : (
                  <>
                    <XIcon className="w-4 h-4 mr-2" /> Continue with X
                  </>
                )}
              </Button>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
